module["exports"] = [
  "no",
  "com",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/internet/domain_suffix.js
// module id = 1156
// module chunks = 0